import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getBackground } from "../../utils/layoutUtils";

const TEMAS = {
  original:    { bgGradient: "linear-gradient(180deg,#a8d5ba 45%,#f4a6cd 45%)",  header: "#a8d5ba",  stats: "#f4a6cd",  titleColor: "#8b4513", border: "#a8d5ba", checkColor: "#a8d5ba", btnBorder: "#a8d5ba", btnColor: "#8b4513",  cardAdulto: "linear-gradient(135deg,#f8f9fa,#e9ecef)",                      cardNaoPag: "linear-gradient(135deg,#a8d5ba,rgba(145,199,168,.37))",         cardPagante: "linear-gradient(135deg,rgba(38,176,255,.43),rgba(38,176,255,.26))", recadoBorder: "#a8d5ba", recadoBg: "rgba(168,213,186,.12)", modalTitle: "#8b4513", btnSave: "#a8d5ba", btnCancel: "#f4a6cd" },
  minimalista: { bgGradient: "linear-gradient(180deg,#f0f0f0 45%,#e5e5e5 45%)",  header: "#111",     stats: "#e8e8e8",  titleColor: "#111",    border: "#ccc",    checkColor: "#333",    btnBorder: "#ccc",    btnColor: "#333",    cardAdulto: "linear-gradient(135deg,#fafafa,#f0f0f0)",                       cardNaoPag: "linear-gradient(135deg,#e8e8e8,#ddd)",                          cardPagante: "linear-gradient(135deg,#e0e8ff,#d4deff)",                           recadoBorder: "#ccc",    recadoBg: "#f5f5f5",               modalTitle: "#111",    btnSave: "#333",    btnCancel: "#888"    },
  elegante:    { bgGradient: "linear-gradient(180deg,#1a1a1a 45%,#111 45%)",     header: "#111",     stats: "#1a1a1a",  titleColor: "#c9a84c", border: "#333",    checkColor: "#c9a84c", btnBorder: "#c9a84c", btnColor: "#c9a84c", cardAdulto: "linear-gradient(135deg,#252525,#1e1e1e)",                       cardNaoPag: "linear-gradient(135deg,#2a2218,#241d14)",                       cardPagante: "linear-gradient(135deg,#1a2030,#141828)",                           recadoBorder: "#333",    recadoBg: "rgba(201,168,76,.06)",  modalTitle: "#c9a84c", btnSave: "#c9a84c", btnCancel: "#555"    },
  moderno:     { bgGradient: "linear-gradient(180deg,#4f46e5 45%,#3730a3 45%)",  header: "#4f46e5",  stats: "#3730a3",  titleColor: "white",   border: "#6366f1", checkColor: "#a5b4fc", btnBorder: "rgba(255,255,255,.4)", btnColor: "white", cardAdulto: "linear-gradient(135deg,#eef2ff,#e0e7ff)",               cardNaoPag: "linear-gradient(135deg,#dbeafe,#bfdbfe)",                       cardPagante: "linear-gradient(135deg,#ede9fe,#ddd6fe)",                           recadoBorder: "#c7d2fe", recadoBg: "rgba(99,102,241,.06)",  modalTitle: "#4f46e5", btnSave: "#4f46e5", btnCancel: "#6b7280" },
  festivo:     { bgGradient: "linear-gradient(180deg,#ff6b6b 45%,#ffd93d 45%)",  header: "#ff6b6b",  stats: "#ffd93d",  titleColor: "#c0392b", border: "#ff6b6b", checkColor: "#ff6b6b", btnBorder: "#ff6b6b", btnColor: "#c0392b", cardAdulto: "linear-gradient(135deg,#fffdf5,#fff8e1)",                       cardNaoPag: "linear-gradient(135deg,rgba(255,107,107,.2),rgba(255,107,107,.08))", cardPagante: "linear-gradient(135deg,rgba(107,207,127,.25),rgba(107,207,127,.1))",recadoBorder: "#ffd93d", recadoBg: "rgba(255,217,61,.1)",   modalTitle: "#c0392b", btnSave: "#ff6b6b", btnCancel: "#ffa500" },
  monica:      { bgGradient: "linear-gradient(180deg,#e63946 45%,#2563eb 45%)",  header: "#e63946",  stats: "#2563eb",  titleColor: "white",   border: "#ffd60a", checkColor: "#ffd60a", btnBorder: "rgba(255,255,255,.5)", btnColor: "white", cardAdulto: "linear-gradient(135deg,#fff5f5,#fee2e2)",               cardNaoPag: "linear-gradient(135deg,#fefce8,#fef9c3)",                       cardPagante: "linear-gradient(135deg,#eff6ff,#dbeafe)",                           recadoBorder: "#fde68a", recadoBg: "rgba(255,214,10,.08)",  modalTitle: "#e63946", btnSave: "#e63946", btnCancel: "#2563eb" },
  frozen:      { bgGradient: "linear-gradient(180deg,#1b4965 45%,#4a9aba 45%)",  header: "#1b4965",  stats: "#4a9aba",  titleColor: "white",   border: "#90e0ef", checkColor: "#90e0ef", btnBorder: "rgba(255,255,255,.5)", btnColor: "white", cardAdulto: "linear-gradient(135deg,#caf0f8,#ade8f4)",               cardNaoPag: "linear-gradient(135deg,#90e0ef,#48cae4)",                       cardPagante: "linear-gradient(135deg,#e8f4fd,#d0ebf7)",                           recadoBorder: "#90e0ef", recadoBg: "rgba(74,154,186,.08)",  modalTitle: "#1b4965", btnSave: "#1b4965", btnCancel: "#4a9aba" },
  stitch:      { bgGradient: "linear-gradient(180deg,#0077b6 45%,#00b4d8 45%)",  header: "#0077b6",  stats: "#023e8a",  titleColor: "white",   border: "#90e0ef", checkColor: "#48cae4", btnBorder: "rgba(255,255,255,.5)", btnColor: "white", cardAdulto: "linear-gradient(135deg,#caf0f8,#ade8f4)",               cardNaoPag: "linear-gradient(135deg,rgba(0,150,199,.2),rgba(0,180,216,.12))", cardPagante: "linear-gradient(135deg,rgba(144,224,239,.4),rgba(144,224,239,.2))", recadoBorder: "#90e0ef", recadoBg: "rgba(0,119,182,.06)",   modalTitle: "#0077b6", btnSave: "#0077b6", btnCancel: "#00b4d8" },
};

const btnStyle = {
  background: "rgba(255,255,255,0.9)",
  border: "2px solid #a8d5ba",
  color: "#8b4513",
  padding: "10px 20px",
  borderRadius: 25,
  fontWeight: 600,
  cursor: "pointer",
  fontSize: 13,
  fontFamily: "inherit",
  textDecoration: "none",
  display: "inline-block",
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  border: "2px solid #ddd",
  borderRadius: 8,
  fontSize: 16,
  background: "white",
  fontFamily: "inherit",
  outline: "none",
  boxSizing: "border-box",
};

const hexToRgba = (hex, alpha) => {
  if (!hex || !/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(hex)) return null;
  const normalized = hex.length === 4
    ? `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`
    : hex;
  const value = normalized.replace("#", "");
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const themedGradient = (color, fallback, alphaA = 0.2, alphaB = 0.08) => {
  const first = hexToRgba(color, alphaA);
  const second = hexToRgba(color, alphaB);
  return first && second ? `linear-gradient(135deg, ${first}, ${second})` : fallback;
};

const isConfirmacaoRecusada = (confirmacao) => {
  const status = confirmacao.status;
  return status === 2 || String(status) === "2" || String(status).toLowerCase() === "recusado";
};

const agruparConfirmacoesPorFamilia = (confirmacoes) => {
  const grupos = new Map();

  confirmacoes.forEach((confirmacao) => {
    const key = confirmacao.codigoConfirmacao
      ? `codigo:${confirmacao.codigoConfirmacao}`
      : `confirmacao:${confirmacao.id}`;

    if (!grupos.has(key)) {
      grupos.set(key, {
        key,
        codigoConfirmacao: confirmacao.codigoConfirmacao,
        grupoConvite: confirmacao.grupoConvite,
        confirmacoes: [],
      });
    }

    const grupo = grupos.get(key);
    grupo.confirmacoes.push(confirmacao);
    if (!grupo.grupoConvite && confirmacao.grupoConvite) {
      grupo.grupoConvite = confirmacao.grupoConvite;
    }
  });

  return Array.from(grupos.values()).map((grupo) => ({
    ...grupo,
    recado: obterRecadoGrupo(grupo.confirmacoes),
  }));
};

const obterRecadoGrupo = (confirmacoes) => {
  return [...confirmacoes]
    .sort((a, b) => b.id - a.id)
    .map((confirmacao) => confirmacao.recado?.trim())
    .find(Boolean) || null;
};

const obterTituloGrupo = (grupo) => {
  if (grupo.grupoConvite) return grupo.grupoConvite;
  if (grupo.confirmacoes.length > 1) return "Família/Grupo";
  return grupo.confirmacoes[0]?.nomeConvidado ?? "Confirmação";
};

const obterResumoGrupo = (confirmacoes) => {
  const recusados = confirmacoes.filter(isConfirmacaoRecusada).length;
  const presentes = confirmacoes.filter((c) => !isConfirmacaoRecusada(c));
  const adultos = presentes.filter((c) => c.tipo === "adulto").length;
  const criancas = presentes.length - adultos;
  const partes = [];

  if (adultos > 0) partes.push(`${adultos} ${adultos === 1 ? "adulto" : "adultos"}`);
  if (criancas > 0) partes.push(`${criancas} ${criancas === 1 ? "criança" : "crianças"}`);
  if (recusados > 0) partes.push(`${recusados} não ${recusados === 1 ? "vai" : "vão"}`);

  return partes.join(" · ");
};

const obterLabelTipo = (confirmacao) => {
  if (isConfirmacaoRecusada(confirmacao)) return "Não vai";
  if (confirmacao.tipo === "adulto") return "Adulto";
  if (confirmacao.tipo === "crianca-nao-pagante") return `Criança ${confirmacao.idade} ano${confirmacao.idade === 1 ? "" : "s"} · não pagante`;
  return `Criança ${confirmacao.idade} ano${confirmacao.idade === 1 ? "" : "s"} · pagante`;
};

const obterCardGrupoBg = (confirmacoes, tema) => {
  if (confirmacoes.every(isConfirmacaoRecusada)) return tema.cardRecusado;
  if (confirmacoes.some((c) => c.tipo === "crianca-pagante")) return tema.cardPagante;
  if (confirmacoes.some((c) => c.tipo === "crianca-nao-pagante")) return tema.cardNaoPag;
  return tema.cardAdulto;
};

const resolveTema = (templateId, layoutConfig) => {
  const base = TEMAS[templateId] || TEMAS.original;
  const backgroundOverride = getBackground(layoutConfig);
  const header = layoutConfig?.headerBg ?? base.header;
  const headerTextColor = layoutConfig?.headerTitleColor ?? "white";
  const stats = layoutConfig?.dateBg ?? layoutConfig?.rsvpBg ?? base.stats;
  const accent = layoutConfig?.rsvpSubmitButtonBg ?? layoutConfig?.rsvpSectionTitleColor ?? header;
  const contentTitleColor = layoutConfig?.rsvpSectionTitleColor ?? layoutConfig?.rsvpPeopleTitleColor ?? base.titleColor;
  const cardAdulto = layoutConfig?.rsvpPeopleBg ?? base.cardAdulto;
  const cardNaoPag = themedGradient(layoutConfig?.rsvpSectionBg ?? layoutConfig?.rsvpPeopleBg ?? accent, base.cardNaoPag);
  const cardPagante = themedGradient(layoutConfig?.rsvpMessageBg ?? layoutConfig?.rsvpPeopleBg ?? accent, base.cardPagante, 0.28, 0.12);
  const cardRecusado = themedGradient("#ef4444", "linear-gradient(135deg,#fff1f2,#ffe4e6)", 0.15, 0.08);

  return {
    ...base,
    bgGradient: backgroundOverride ?? base.bgGradient,
    header,
    headerTextColor,
    stats,
    titleColor: contentTitleColor,
    border: layoutConfig?.rsvpSectionTitleColor ?? layoutConfig?.rsvpPeopleTitleColor ?? base.border,
    checkColor: accent,
    btnBorder: accent,
    btnColor: layoutConfig?.rsvpAddButtonTextColor ?? layoutConfig?.dateTextColor ?? base.btnColor,
    btnBg: layoutConfig?.rsvpAddButtonBg ?? "rgba(255,255,255,0.9)",
    cardAdulto,
    cardNaoPag,
    cardPagante,
    cardRecusado,
    cardTextColor: layoutConfig?.rsvpPeopleTitleColor ?? contentTitleColor,
    recadoBorder: layoutConfig?.rsvpMessageTitleColor ?? layoutConfig?.rsvpSectionTitleColor ?? base.recadoBorder,
    recadoBg: layoutConfig?.rsvpMessageBg ?? base.recadoBg,
    recadoColor: layoutConfig?.rsvpMessageTextColor ?? "#555",
    modalTitle: layoutConfig?.rsvpSectionTitleColor ?? contentTitleColor,
    btnSave: layoutConfig?.rsvpSubmitButtonBg ?? base.btnSave,
    btnSaveText: layoutConfig?.rsvpSubmitButtonTextColor ?? "white",
    btnCancel: layoutConfig?.rsvpAddButtonBg ?? base.btnCancel,
    btnCancelText: layoutConfig?.rsvpAddButtonTextColor ?? "white",
    inputBg: layoutConfig?.rsvpInputBg ?? "white",
    inputTextColor: layoutConfig?.rsvpInputTextColor ?? "#333",
  };
};

export default function ListaConfirmacoes({ eventId, embedded = false } = {}) {
  const { id: routeId } = useParams();
  const id = eventId ?? routeId;
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [filtros, setFiltros] = useState({
    adultos: true,
    criancasNaoPagantes: true,
    criancasPagantes: true,
    recusados: true,
  });
  const [ordenacao, setOrdenacao] = useState("nome-asc");
  const [editModal, setEditModal] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [desconfirmandoId, setDesconfirmandoId] = useState(null);
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(null);

  const carregar = useCallback(async (silencioso = false) => {
    if (!silencioso) setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/confirmacoes/lista/${id}`,
        silencioso ? { metadata: { ignoreLoading: true } } : undefined
      );
      setDados(res.data);
      setUltimaAtualizacao(new Date());
      setErro(null);
    } catch {
      setErro("Evento não encontrado ou indisponível.");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    carregar();
    const interval = setInterval(() => carregar(true), 30000);
    return () => clearInterval(interval);
  }, [carregar]);

  const abrirEdit = async (confirmacaoId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/confirmacoes/api/${confirmacaoId}`);
      setEditModal(res.data);
    } catch {
      alert("Erro ao carregar dados da confirmação");
    }
  };

  const salvarEdit = async (e) => {
    e.preventDefault();
    if (!editModal) return;
    setSalvando(true);
    try {
      await axios.put(`${process.env.REACT_APP_API}/confirmacoes/api/${editModal.id}`, {
        nomeConvidado: editModal.nomeConvidado,
        recado: editModal.recado || null,
        crianca: editModal.crianca,
        idade: editModal.crianca ? editModal.idade : null,
      });
      setEditModal(null);
      carregar(true);
    } catch {
      alert("Erro ao salvar alterações");
    } finally {
      setSalvando(false);
    }
  };

  const desconfirmar = async (confirmacao) => {
    const acao = isConfirmacaoRecusada(confirmacao) ? "Remover resposta de" : "Desconfirmar";
    const confirmado = window.confirm(`${acao} ${confirmacao.nomeConvidado}?`);
    if (!confirmado) return;

    setDesconfirmandoId(confirmacao.id);
    try {
      await axios.delete(`${process.env.REACT_APP_API}/confirmacoes/api/${confirmacao.id}`);
      await carregar(true);
    } catch {
      alert("Erro ao desconfirmar presença");
    } finally {
      setDesconfirmandoId(null);
    }
  };

  const exportarExcel = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/confirmacoes/exportar/${id}`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      const disposition = res.headers["content-disposition"] || "";
      const match = disposition.match(/filename="?([^"]+)"?/i);
      link.download = match?.[1] || `confirmacoes_evento_${id}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      alert("Erro ao exportar confirmações");
    }
  };

  const listaFiltrada = () => {
    if (!dados) return [];
    return dados.confirmacoes
      .filter((c) => {
        if (isConfirmacaoRecusada(c)) return filtros.recusados;
        if (c.tipo === "adulto") return filtros.adultos;
        if (c.tipo === "crianca-nao-pagante") return filtros.criancasNaoPagantes;
        if (c.tipo === "crianca-pagante") return filtros.criancasPagantes;
        return true;
      })
      .sort((a, b) => {
        switch (ordenacao) {
          case "nome-asc":  return a.nomeConvidado.localeCompare(b.nomeConvidado, "pt-BR");
          case "nome-desc": return b.nomeConvidado.localeCompare(a.nomeConvidado, "pt-BR");
          case "data-asc":  return a.id - b.id;
          case "data-desc": return b.id - a.id;
          default:          return 0;
        }
      });
  };

  const loadingStyle = {
    minHeight: embedded ? 280 : "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: embedded ? "white" : "linear-gradient(180deg, #a8d5ba 45%, #f4a6cd 45%)",
    borderRadius: embedded ? 20 : undefined,
  };

  if (loading) {
    return (
      <div style={loadingStyle}>
        <p style={{ color: embedded ? "#8b4513" : "white", fontSize: 20, fontWeight: 600 }}>Carregando...</p>
      </div>
    );
  }

  if (erro || !dados) {
    return (
      <div style={loadingStyle}>
        <div style={{ background: "white", borderRadius: 20, padding: "40px 60px", textAlign: "center" }}>
          <p style={{ fontSize: 24, color: "#8b4513" }}>😔 {erro ?? "Evento não encontrado"}</p>
        </div>
      </div>
    );
  }

  const { evento, stats } = dados;
  const tema = resolveTema(evento.templateId, evento.layoutConfig);
  const lista = listaFiltrada();
  const grupos = agruparConfirmacoesPorFamilia(lista);

  const statCards = [
    { key: "adultos",            label: "Adultos",                                                                              count: stats.totalAdultos,            filtroKey: "adultos" },
    { key: "criancasNaoPagantes",label: stats.totalCriancasNaoPagantes === 1 ? "Criança Não Pagante" : "Crianças Não Pagantes", count: stats.totalCriancasNaoPagantes, filtroKey: "criancasNaoPagantes" },
    { key: "criancasPagantes",   label: stats.totalCriancasPagantes === 1 ? "Criança Pagante" : "Crianças Pagantes",            count: stats.totalCriancasPagantes,    filtroKey: "criancasPagantes" },
    { key: "total",              label: "Total Pagantes",                                                                       count: stats.totalPagantes,            filtroKey: null },
    { key: "recusados",          label: "Não vão",                                                                              count: stats.totalRecusados ?? 0,      filtroKey: "recusados" },
  ];

  const pageStyle = {
    minHeight: embedded ? undefined : "100vh",
    background: tema.bgGradient,
    padding: "20px",
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    overflowX: "hidden",
    borderRadius: embedded ? 20 : undefined,
  };

  const decoracaoStyle = {
    position: embedded ? "absolute" : "fixed",
    inset: 0,
    pointerEvents: "none",
    zIndex: 0,
  };

  return (
    <div style={pageStyle}>
      {/* Decorações */}
      <div style={decoracaoStyle}>
        {[
          { emoji: "✨", top: "15%", left: "15%" },
          { emoji: "⭐", top: "25%", right: "20%" },
          { emoji: "✨", bottom: "30%", left: "10%" },
          { emoji: "💫", bottom: "15%", right: "15%" },
        ].map((s, i) => (
          <span key={i} style={{ position: "absolute", fontSize: 18, opacity: 0.6, ...s }}>{s.emoji}</span>
        ))}
      </div>

      <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 1 }}>

        {/* Header */}
        <div style={{ background: tema.header, borderRadius: "20px 20px 0 0", padding: "30px", textAlign: "center" }}>
          <h1 style={{
            fontFamily: "'Dancing Script', cursive",
            fontSize: "clamp(1.8em, 5vw, 2.5em)",
            color: tema.headerTextColor,
            fontWeight: 700,
            textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
            marginBottom: 8,
          }}>Lista de Confirmações</h1>
          <p style={{ fontSize: "1.15em", color: tema.headerTextColor, opacity: 0.92, fontWeight: 500 }}>{evento.nome}</p>
          {ultimaAtualizacao && (
            <p style={{ fontSize: 12, color: tema.headerTextColor, opacity: 0.72, marginTop: 6 }}>
              Atualizado às {ultimaAtualizacao.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
            </p>
          )}
        </div>

        {/* Stats + ações */}
        <div style={{ background: tema.stats, padding: "28px 28px 24px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 16, marginBottom: 20 }}>
            {statCards.map((s) => {
              const ativo = !s.filtroKey || filtros[s.filtroKey];
              return (
                <div
                  key={s.key}
                  onClick={() => s.filtroKey && setFiltros((f) => ({ ...f, [s.filtroKey]: !f[s.filtroKey] }))}
                  style={{
                    background: ativo ? "rgba(255,255,255,0.92)" : "rgba(200,200,200,0.45)",
                    borderRadius: 15,
                    padding: "18px 16px",
                    textAlign: "center",
                    cursor: s.filtroKey ? "pointer" : "default",
                    opacity: ativo ? 1 : 0.55,
                    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    position: "relative",
                    userSelect: "none",
                    transition: "all 0.2s",
                  }}
                >
                  {s.filtroKey && (
                    <input
                      type="checkbox"
                      checked={filtros[s.filtroKey]}
                      onChange={() => setFiltros((f) => ({ ...f, [s.filtroKey]: !f[s.filtroKey] }))}
                      onClick={(e) => e.stopPropagation()}
                      style={{ position: "absolute", top: 10, right: 10, width: 20, height: 20, accentColor: tema.checkColor, cursor: "pointer" }}
                    />
                  )}
                  <div style={{ fontSize: "2.8em", fontWeight: 700, color: tema.titleColor, lineHeight: 1 }}>{s.count}</div>
                  <div style={{ color: "#666", fontSize: "0.9em", fontWeight: 600, marginTop: 4 }}>{s.label}</div>
                </div>
              );
            })}
          </div>

          <div style={{ display: "flex", gap: 12, justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <button onClick={() => carregar(true)} style={{ ...btnStyle, background: tema.btnBg, border: `2px solid ${tema.btnBorder}`, color: tema.btnColor }}>🔄 Atualizar Lista</button>
              <button type="button" onClick={exportarExcel} style={{ ...btnStyle, background: tema.btnBg, border: `2px solid ${tema.btnBorder}`, color: tema.btnColor }}>
                📊 Exportar Excel
              </button>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <label style={{ fontWeight: 600, color: tema.btnColor, fontSize: 13, whiteSpace: "nowrap" }}>Ordenar por:</label>
              <select value={ordenacao} onChange={(e) => setOrdenacao(e.target.value)} style={{ ...btnStyle, background: tema.btnBg, padding: "10px 14px", border: `2px solid ${tema.btnBorder}`, color: tema.btnColor }}>
                <option value="nome-asc">Nome A→Z</option>
                <option value="nome-desc">Nome Z→A</option>
                <option value="data-asc">Confirmação ↑</option>
                <option value="data-desc">Confirmação ↓</option>
              </select>
            </div>
          </div>
        </div>

        {/* Lista */}
        <div style={{ background: "white", borderRadius: "0 0 20px 20px", padding: "28px 28px 40px" }}>
          <h2 style={{
            fontFamily: "'Dancing Script', cursive",
            fontSize: "clamp(1.6em, 4vw, 2.2em)",
            color: tema.titleColor === "white" ? tema.header : tema.titleColor,
            textAlign: "center",
            marginBottom: 28,
          }}>Respostas por Família</h2>

          {lista.length === 0 ? (
            <div style={{ textAlign: "center", padding: "48px 20px" }}>
              <div style={{ fontSize: 56, marginBottom: 14 }}>😔</div>
              <p style={{ color: "#666", fontSize: 18, fontWeight: 600 }}>
                {dados.confirmacoes.length === 0
                  ? "Nenhuma resposta ainda"
                  : "Nenhuma resposta para os filtros selecionados"}
              </p>
              {dados.confirmacoes.length === 0 && (
                <p style={{ color: "#999", marginTop: 8 }}>As respostas aparecerão aqui conforme as pessoas confirmarem o convite.</p>
              )}
            </div>
          ) : (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(360px, 1fr))",
              gap: 20,
            }}>
              {grupos.map((grupo) => {
                const cardBg = obterCardGrupoBg(grupo.confirmacoes, tema);
                const tituloGrupo = obterTituloGrupo(grupo);
                const resumoGrupo = obterResumoGrupo(grupo.confirmacoes);

                return (
                  <div
                    key={grupo.key}
                    style={{ background: cardBg, border: `2px solid ${tema.border}`, borderRadius: 15, padding: 20, minHeight: 120, transition: "transform 0.25s, box-shadow 0.25s" }}
                    onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.1)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 12,
                        alignItems: "flex-start",
                        marginBottom: 14,
                      }}
                    >
                      <div style={{ minWidth: 0 }}>
                        <div style={{
                          fontSize: "1.15em",
                          fontWeight: 700,
                          color: tema.cardTextColor === "white" ? tema.header : tema.cardTextColor,
                          lineHeight: 1.25,
                          wordBreak: "break-word",
                        }}>
                          {tituloGrupo}
                        </div>
                        <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700, marginTop: 4 }}>
                          {resumoGrupo || `${grupo.confirmacoes.length} pessoa${grupo.confirmacoes.length === 1 ? "" : "s"}`}
                        </div>
                      </div>
                      {grupo.codigoConfirmacao && (
                        <code style={{
                          background: "rgba(255,255,255,0.7)",
                          border: `1px solid ${tema.recadoBorder}`,
                          borderRadius: 999,
                          color: tema.cardTextColor === "white" ? tema.header : tema.cardTextColor,
                          fontSize: 12,
                          fontWeight: 800,
                          padding: "5px 9px",
                          whiteSpace: "nowrap",
                        }}>
                          {grupo.codigoConfirmacao}
                        </code>
                      )}
                    </div>

                    <div style={{ display: "grid", gap: 10, marginBottom: 14 }}>
                      {grupo.confirmacoes.map((c) => (
                        <div
                          key={c.id}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "minmax(0, 1fr) auto",
                            gap: 10,
                            alignItems: "center",
                            background: "rgba(255,255,255,0.62)",
                            border: isConfirmacaoRecusada(c) ? "1px solid rgba(244,63,94,0.22)" : "1px solid rgba(255,255,255,0.78)",
                            borderRadius: 12,
                            padding: "10px 12px",
                          }}
                        >
                          <div style={{ minWidth: 0 }}>
                            <div style={{
                              color: tema.cardTextColor === "white" ? tema.header : tema.cardTextColor,
                              fontSize: 15,
                              fontWeight: 700,
                              lineHeight: 1.25,
                              overflowWrap: "anywhere",
                            }}>
                              {c.nomeConvidado}
                            </div>
                            <div style={{
                              color: isConfirmacaoRecusada(c) ? "#be123c" : "#64748b",
                              fontSize: 12,
                              fontWeight: 700,
                              marginTop: 3,
                            }}>
                              {obterLabelTipo(c)}
                            </div>
                          </div>
                          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                            <button
                              onClick={() => abrirEdit(c.id)}
                              title="Editar"
                              style={{
                                background: "#ffa726",
                                color: "white",
                                width: 34,
                                height: 34,
                                borderRadius: "50%",
                                border: "none",
                                cursor: "pointer",
                                fontSize: 13,
                                boxShadow: "0 2px 5px rgba(255,167,38,0.35)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              ✏️
                            </button>
                            <button
                              onClick={() => desconfirmar(c)}
                              disabled={desconfirmandoId === c.id}
                              title={isConfirmacaoRecusada(c) ? "Remover resposta" : "Desconfirmar"}
                              style={{
                                background: "#fee2e2",
                                color: "#991b1b",
                                width: 34,
                                height: 34,
                                borderRadius: "50%",
                                border: "none",
                                cursor: desconfirmandoId === c.id ? "wait" : "pointer",
                                fontSize: 13,
                                fontWeight: 800,
                                boxShadow: "0 2px 5px rgba(153,27,27,0.12)",
                                opacity: desconfirmandoId === c.id ? 0.6 : 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              ×
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div style={{
                      background: tema.recadoBg,
                      border: `1px solid ${tema.recadoBorder}`,
                      borderRadius: 10,
                      padding: "10px 14px",
                      fontStyle: "italic",
                      color: grupo.recado ? tema.recadoColor : "#999",
                      fontSize: 13,
                      lineHeight: 1.5,
                    }}>
                      {grupo.recado || "Nenhuma mensagem"}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Modal de edição */}
      {editModal && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 }}
          onClick={() => setEditModal(null)}
        >
          <div
            style={{ background: "white", borderRadius: 20, padding: 30, width: "100%", maxWidth: 500, boxShadow: "0 20px 40px rgba(0,0,0,0.3)" }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ fontFamily: "'Dancing Script', cursive", fontSize: "2em", color: tema.modalTitle, textAlign: "center", marginBottom: 24 }}>
              Editar Confirmação
            </h2>

            <form onSubmit={salvarEdit}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", fontWeight: 600, marginBottom: 6, color: "#333", fontSize: 14 }}>Nome do Convidado</label>
                <input
                  type="text"
                  required
                  value={editModal.nomeConvidado}
                  onChange={(e) => setEditModal((m) => ({ ...m, nomeConvidado: e.target.value }))}
                  style={{ ...inputStyle, background: tema.inputBg, color: tema.inputTextColor }}
                />
              </div>

              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", fontWeight: 600, marginBottom: 6, color: "#333", fontSize: 14 }}>👶 É Criança</label>
                <select
                  value={editModal.crianca ? "sim" : "nao"}
                  onChange={(e) =>
                    setEditModal((m) => ({ ...m, crianca: e.target.value === "sim", idade: e.target.value === "nao" ? 0 : m.idade }))
                  }
                  style={{ ...inputStyle, background: tema.inputBg, color: tema.inputTextColor }}
                >
                  <option value="nao">Não</option>
                  <option value="sim">Sim</option>
                </select>
              </div>

              {editModal.crianca && (
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: "block", fontWeight: 600, marginBottom: 6, color: "#333", fontSize: 14 }}>🎂 Idade</label>
                  <input
                    type="number"
                    min="0"
                    max="17"
                    required
                    value={editModal.idade ?? ""}
                    onChange={(e) => setEditModal((m) => ({ ...m, idade: parseInt(e.target.value) || 0 }))}
                    style={{ ...inputStyle, background: tema.inputBg, color: tema.inputTextColor }}
                  />
                </div>
              )}

              <div style={{ marginBottom: 22 }}>
                <label style={{ display: "block", fontWeight: 600, marginBottom: 6, color: "#333", fontSize: 14 }}>💌 Recado (opcional)</label>
                <textarea
                  value={editModal.recado ?? ""}
                  onChange={(e) => setEditModal((m) => ({ ...m, recado: e.target.value }))}
                  rows={3}
                  style={{ ...inputStyle, background: tema.inputBg, color: tema.inputTextColor, resize: "vertical", minHeight: 80, fontFamily: "inherit" }}
                />
              </div>

              <div style={{ display: "flex", gap: 12 }}>
                <button
                  type="button"
                  onClick={() => setEditModal(null)}
                  style={{ flex: 1, padding: "12px 20px", border: "none", borderRadius: 10, background: tema.btnCancel, color: tema.btnCancelText, fontSize: 16, fontWeight: 600, cursor: "pointer" }}
                >Cancelar</button>
                <button
                  type="submit"
                  disabled={salvando}
                  style={{ flex: 1, padding: "12px 20px", border: "none", borderRadius: 10, background: tema.btnSave, color: tema.btnSaveText, fontSize: 16, fontWeight: 600, cursor: "pointer", opacity: salvando ? 0.7 : 1 }}
                >{salvando ? "Salvando..." : "Salvar Alterações"}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
